<template>
	<div>
		<div>
			<h2>新升后端编码规范 v1.5 </h2><br>
			<hr><br>
		</div>
		<div style="padding-left: 80px;">
			<ol>
				<li>
					<h3> MVC 规范</h3><br>
					<ul style="padding-left: 30px;">
						<li>V: view视图层</li>
						<li>C: controller 层/service 层（控制事务）/manager 层（控制缓存）
						</li>
						<li>M: dao 层 <br>
                                        命名去掉数据库的前缀，比如t_user不是TUser应是User
						</li>
						<li>【view】-【controller】-【service】/【manager】-【model】 逐层依赖调用，不能跨层调用
						</li>
					</ul><br>
				</li>
				<li>
					<h3> MVC 命名规范</h3><br>
					<ul style="padding-left: 30px;">
						<li>controller以 XxxController作为后缀<br><br>
						    	@RequestMapping("/模块/类名全小写")<br>
                                           public class 类名Controller {...<br>
								例如@RequestMapping("/sku/goodsstore") 或 @RequestMapping("/sku/goods_store")，不要使用驼峰命名@RequestMapping("/sku/goodsStore")<br><br></li>
						<li> service 以 IXxxService作为接口  ,实现 XxxService ，均以Service作为后缀 <br><br>
						   注入Controller时如果有接口，使用接口注入，型如：<br>
						     @Autowired<br>
                                         private IGoodStoreService goodStoreService;<br><br>

						</li>
						<li>M: dao 层,MyBatis以Dao/Mapper作为后缀,两行以内的SQL尽量写在Mapper接口中</li>
					</ul><br>
				</li>
		
				<li>
					<h3>manager 层规范</h3><br>
					manager 层的作用(引自《阿里 java 手册》)：<br>
					<ul style="padding-left: 30px;">
						<li> 对第三方平台封装的层，预处理返回结果及转化异常信息</li>
						<li>对 Service 层通用能力的下沉，如缓存方案、中间件通用处理</li>
						<li>与 DAO 层交互，对多个 DAO 的组合复用</li><br>
					</ul>
				</li>
		             <li>
					<h3>swagger 接口注释必须加上后端作者，更新时间</h3><br>
				</li>

				<li>
					<h3>javabean 命名规范</h3><br>
					<ul style="padding-left: 30px;">
						<li>javabean 的整体要求</li>
						<ol style="padding-left: 30px;">
							<li>不得有任何的业务逻辑或者计算</li>
							<li>基本数据类型必须使用包装类型（Integer, Double、Boolean 等）</li>
							<li>不允许有任何的默认值</li>
							<li>每个属性必须添加注释，并且必须使用多行注释</li><br>
						</ol>
						<li> javabean 名字划分 </li><br>
					<ol style="padding-left: 30px;">
						<li>实体在“entity”包下，为 数据库持久对象</li>
						<li>后缀 VO 后端 to 前端 的数据封装对象 </li>
						&nbsp;&nbsp;例如: studentVO<br>
						&nbsp;&nbsp;&nbsp;&nbsp;VO 只能用于返回前端、rpc 的业务数据封装对象<br>
						<li>后缀 DTO 前端 to 后端 数据封装对象</li>
						<li>后缀 BO 内部逻辑处理对象</li>
						&nbsp;&nbsp;BO 对象只能用于 service，manager，dao 层，不得用于 controller 层<br><br>
					</ol>
					<br>

					</ul>
				</li>
				<li>
					<h3> 项目内的日期类型必须统一 </h3><br>
					<ul style="padding-left: 30px;">
						<li> jdk8统一使用java.util.Date</li>
						<li> jdk8+以上版本 使用 java.time.LocalDateTime 或者 java.time.LocalDate</li>
					</ul>
					<br>
				</li>
				<li>
					<h3> 默认移动端/PC端后端分离，如共用 </h3><br>
					<ul style="padding-left: 30px;">
						<li> Dao和Service层+Manager层以PC端为准</li>
						<li> 移动端Controller调用PC端Service层</li>
						<li> 避免一张表多个映射，要保证映射的全局唯一性</li>
					</ul>
					<br>
				</li>
				<li>
					<h3>货币单位以整数计，以分为单位 </h3><br>
					<ul style="padding-left: 30px;">
						<li> 与第三方支付平台保持一致</li>
					</ul>
					<br>
				</li>

			</ol>

			<br>



		</div>
	</div>
</template>

<script>

export default {
	name: 'dev-back',
	data() {
		return {


		};
	},

	methods: {

	},
	mounted() {

	}
};
</script>

<style lang="scss" scoped="scoped"></style>
